import * as types from '../mutation-types'
import iframes from '@/api/iframe'

const state = {
  iframe: []
}

const getters = {
  iframe: (state) => {
    return state.iframe
  }
}

const actions = {
  getIframeBySlug ({ commit, state }, route) {
    return new Promise((resolve, reject) => {
      iframes.getIframeBySlug(route).then((response) => {
        const iframe = response.data.result.iframe
        commit(types.ADD_IFRAME, iframe)
        resolve(iframe)
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.ADD_IFRAME] (state, iframe) {
    state.iframe = iframe
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
